import OfferInterface from 'interfaces/offer.interface';

const PROMOTED_OFFER_VALUE = 'product_page';

export default function getPromotedOffers(offers: OfferInterface[]): OfferInterface[] {
    const promotedOffers = offers.filter(item => item.dealer.badges.some(item => item.type === PROMOTED_OFFER_VALUE));

    return promotedOffers.sort((offer1, offer2) => offer2.score - offer1.score);
}
